import parse from 'date-fns/parse';

export default function parseDate(input: number | string, possibleStringFormat: string): Date {
  if (typeof input === 'number') {
    return new Date(input);
  }
  return parse(input, possibleStringFormat, new Date());
}
